import { configureStore } from '@reduxjs/toolkit';
import AppReducer from 'containers/App/slices';
import workSpacesSlices from 'containers/App/workSpacesSlices';
import billingReduces from 'pages/BillingProcess/slices';
import cpapInstructionsSlices from 'pages/Cpap/slices';
import updateCpapInstructionsSlices from 'pages/CpapDetail/slices';
import medicalSlices from 'pages/ListMedicalInstitution/slice';
import medicalDetailSlice from 'pages/MedicalInstitutionRegister/MedicalInstitutionDetail/slice';
import medicalRegisterSlices from 'pages/MedicalInstitutionRegister/slices';
import medicalInstitutionSlices from 'pages/Register/RegisterFirstStep/slices';
import registerSlices from 'pages/Register/slices';
import consultationHistorySlice from '../pages/ConsultationHistory/slices';
import payoutSlice from '../pages/DepositManagement/slice';
import billingListSlice from '../pages/ListBilling/slice';
import machineSlices from '../pages/ListMachine/slices';
import machineRegisterSlices from '../pages/MachineRegister/slices';
import receivingSlice from '../pages/RegisterReceivingStatus/slice';

const reducer = {
  workSpaces: workSpacesSlices,
  app: AppReducer,
  register: registerSlices,
  cpapInstructions: cpapInstructionsSlices,
  updateItem: updateCpapInstructionsSlices,
  medicalInstitution: medicalInstitutionSlices,
  medicals: medicalSlices,
  medicalDetail: medicalDetailSlice,
  medicalRegister: medicalRegisterSlices,
  billingStore: billingReduces,
  machine: machineSlices,
  machineequipment: machineRegisterSlices,
  billingList: billingListSlice,
  payoutSlice: payoutSlice,
  receivingSlice: receivingSlice,
  consultationHistory: consultationHistorySlice,
};

const store = configureStore({
  reducer: reducer,
});

export type RootState = ReturnType<typeof store.getState>;

export default store;
